import React from "react";
import { Box, Container, Paper, Stack, Typography } from "@mui/material";
import BAARequestForm from "features/baa/BAARequestForm";

/**
 * Public landing for the institutional Business Associate Agreement request.
 * Linked from the compliance-officer messaging on the VoxPont marketing page.
 * No authentication required.
 */
export default function VoxPontBaaRequestPage() {
  return (
    <Box sx={{ bgcolor: "background.default", minHeight: "100vh", py: { xs: 4, md: 8 } }}>
      <Container maxWidth="sm">
        <Stack spacing={1.5} sx={{ mb: 4 }}>
          <Typography variant="overline" color="text.secondary">
            For compliance officers
          </Typography>
          <Typography variant="h4" component="h1">
            Request a Business Associate Agreement
          </Typography>
          <Typography color="text.secondary">
            Tell us about your institution and the person authorized to sign, and
            we&apos;ll get your Business Associate Agreement to them to review and
            sign.
          </Typography>
        </Stack>

        <Paper variant="outlined" sx={{ p: { xs: 2.5, md: 4 } }}>
          <BAARequestForm />
        </Paper>
      </Container>
    </Box>
  );
}
